'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStaticPageUrl = exports.getStaticHtmlResourceName = undefined;

var _staticPageConstants = require('./staticPageConstants');

var getStaticHtmlResourceName = exports.getStaticHtmlResourceName = function getStaticHtmlResourceName(htmlDocName) {
  return '/html/' + htmlDocName + '.html';
};
var getStaticPageUrl = exports.getStaticPageUrl = function getStaticPageUrl(htmlDocName) {
  return '' + _staticPageConstants.URL_PREFIX + htmlDocName;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/static/staticResourceUtil.js
// module id = 443
// module chunks = 0